import React, { Component } from 'react'
import {Switch, Route, Redirect, withRouter} from 'react-router'
import Files from './Files/Files';
import Templates from './templates/Templates';
import Sections from './sections/Sections';

const Routes = ({chosenDepartment, departmentPermission}) => { 

    return (
        <Switch>
            <Route exact path="/">
                <Redirect to="/files" />
            </Route>
            <Route path="/files">
            <Files/>
            </Route>
            <Route path="/templates">
            <Templates chosenDepartment={chosenDepartment} departmentPermission={departmentPermission}/>
            </Route>
            <Route path="/sections">
            <Sections chosenDepartment={chosenDepartment} departmentPermission={departmentPermission}/>
            </Route>   
       
        </Switch>
    )
}
export default Routes